export {getRelaySockets, joinRoom, selfId} from './nostr.js'
